module.exports = __webpack_public_path__ + "media/svg/flag-5d7b62fa.svg";